export default "__VITE_ASSET__gm70aYqr__"